// src/app/app-routing.module.ts
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {environment} from '../environments/environment';
import {
  oakvilleRoutes, muskokaRoutes, muskokaPrivateRoutes
} from './app-routing.config';

export const selectedRoutes = environment.hostname.includes('oakville')
  ? oakvilleRoutes
  : environment.hostname.includes('muskoka-private')
    ? muskokaPrivateRoutes
    : muskokaRoutes;
console.log('selectedRoutes: ', selectedRoutes);

@NgModule({
  imports: [
    RouterModule.forRoot(
      selectedRoutes,
      {
        enableTracing: false,
        initialNavigation: 'enabledBlocking',
        useHash: false
      }
    )
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
